<template>
    <Fragment>
        <SelectedReseller
            :reseller="selectedReseller"
            @reloadResellers="reloadResellers"
            @deleteReseller="removeSelectedAndEmitDelete"
            @deactivateReseller="deactivateSelectedAndEmit"
            @activateReseller="activateSelectedAndEmit"
        />

        <h4>{{ t('general.resellers') }}</h4>

        <div class="resellers">
            <ResellerBlock
                v-for="reseller in resellers"
                :key="reseller.id"
                :id="reseller.id"
                :clientsCount="reseller.clients.length"
                :selectedReseller="selectedReseller && selectedReseller.id === reseller.id"
                :reseller="reseller.company_name"
                :active="reseller.active === 1"
                :isPending="!reseller.invite_accepted && !reseller.setup_completed"
                @click="selectReseller(reseller)"
                :logo="reseller.logo"
            />
        </div>

        <Alert :show="!resellers.length">{{ t('general.no_results_found') }}</Alert>
    </Fragment>
</template>
<script>
import swal from 'sweetalert';
import { Fragment } from 'vue-fragment';
import Alert from '@/components/Alert/Alert';
import ResellerBlock from './ResellerBlock';
import SelectedReseller from './SelectedReseller';

export default {
    name: 'AdminResellersBlocks',

    props: {
        resellers: {
            type: Array,
            requried: true,
        },
    },

    components: {
        ResellerBlock,
        SelectedReseller,
        Fragment,
        Alert,
    },

    data() {
        return {
            selectedReseller: null,
        };
    },

    methods: {
        selectReseller(reseller) {
            if (this.selectedReseller && (reseller.id === this.selectedReseller.id)) return this.selectedReseller = null;
            this.selectedReseller = reseller;
        },

        removeSelectedAndEmitDelete() {
            swal(
                this.$translate.text('alert.confirm.delete'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    const reseller = { ...this.selectedReseller };
                    this.$emit('deleteReseller', reseller.id);
                    this.selectedReseller = null;
                }
            });
        },

        reloadResellers() {
            this.selectedReseller = null;
            this.$emit('reloadResellers');
        },

        activateSelectedAndEmit() {
            swal(
                this.$translate.text('alert.confirm.disable'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    const reseller = { ...this.selectedReseller };
                    this.$emit('activateReseller', reseller.id);
                    this.selectedReseller = null;
                }
            });
        },

        deactivateSelectedAndEmit() {
            swal(
                this.$translate.text('alert.confirm.disable'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    const reseller = { ...this.selectedReseller };
                    this.$emit('deactivateReseller', reseller.id);
                    this.selectedReseller = null;
                }
            });
        },
    },

    // computed: {
    // activeResellers() {
    //     return this.resellers.filter((reseller) => reseller.active === 1);
    // },
    // },
};
</script>
<style lang="scss">
.resellers {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 8px;

    @media(min-width: 992px) {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    @media(min-width: 1200px) {
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }

    .block {
        margin-top: 64px;
        cursor: pointer;
    }

    .block.deactive {
        opacity: 0.5;
    }

    .block p {
        margin-top: 10px;
        margin-bottom: 10px;
    }
}
</style>
